import { SearchType } from '@/types/search/SearchType.type'

export function getAllTypes() {
    return Object.values(SearchType)
}

export function isFirstLoaded(state: any): boolean {
    const types = getAllTypes()
    for (const type of types) {
        if (!state.lists[type].firstLoaded) {
            return false
        }
    }

    return true
}
